import React, { useEffect, useContext, useState } from "react";
//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";

//functions
import {
  _t,
  getCookie,
  tableLoading,
  customStyle,
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";
import Select from "react-select";

//3rd party packages
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

//pages & includes
import ManageSidebar from "../ManageSidebar";

//context consumer
import { SettingsContext } from "../../../../../contexts/Settings";
import { ToastError } from "../../../../../functions/ToastShow";
import CustomSpinLoader from "../../../../components/CustomSpinLoader";

const webMapping = [
  {
    id: 1,
    name: "Branch",
    value: "branches"
  },
  {
    id: 2,
    name: "Food Item",
    value: "food_items"
  },
  {
    id: 3,
    name: "Food Groups",
    value: "food_groups"

  },
  {
    id: 4,
    name: "Property Groups",
    value: "property_groups"
  },
  {
    id: 5,
    name: "Property Items",
    value: "property_items"
  },
  {
    id: 6,
    name: "Variations",
    value: "variations"
  },

]

const WebMapping = () => {

  const { t } = useTranslation();

  let {
    loading,
    setLoading,
    dataPaginating,
  } = useContext(SettingsContext);



  const [mapping, setMapping] = useState({
    type: null,
    pos_id: "",
    web_id: "",
  });

  //mapping list
  const [mappingList, setMappingList] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const [isActionLoading, setIsActionLoading] = useState(false);

  const fetchingMapping = async (type) => {

    setIsFetching(true);

    const url = BASE_URL + "/settings/get-web-pos-mapping-by-type";

    const res = await axios.post(url, {
      type: type?.value,
    }, {
      headers: { Authorization: `Bearer ${getCookie()}` },
    });

    if (res.data) {
      // console.log(res.data,"resp");
      setMappingList(res.data);
    }

    setIsFetching(false);
  }

  const handleChange = (e) => {
    setMapping({ ...mapping, [e.target.name]: e.target.value });
  };

  const handleSetType = (type) => {
    setMapping({ ...mapping, type: type });
    fetchingMapping(type);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (mapping.type !== null) {

      let formData = {
        type: mapping.type?.value,
        pos_id: mapping.pos_id,
        web_id: mapping.web_id,
      };

      const url = BASE_URL + "/settings/web-pos-mapping";
      setLoading(true);

      try {
        const res = await axios.post(url, formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        });

        if (res.data) {

          setMapping((pre) => ({
            ...pre,
            pos_id: "",
            web_id: "",
          }));

          const successMessage = res.data.message || t("Mapping saved successfully");
          toast.success(<span style={{ whiteSpace: "pre-line" }}>{successMessage}</span>, {
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          });

          fetchingMapping(mapping.type);
        }

        setLoading(false);
      } catch (err) {
        setLoading(false);
        const errorMessage = err?.response?.data?.message || t("Please try again");
        ToastError({ title: errorMessage });
      }
    } else {
      ToastError({ title: t("Please fill required fields") });
    }
  };


  const handleItemChange = (name, value, index) => {
    let newMappingList = [...mappingList];
    newMappingList[index][name] = value;
    setMappingList(newMappingList);
  };

  const handleUpdate = async (item) => {
    const url = BASE_URL + "/settings/update-web-mapping";
    setIsActionLoading(true);

    try {
      const res = await axios.post(url, {
        id: item.id,
        type: mapping.type?.value,
        pos_id: Number(item.pos_id),
        web_id: Number(item.indolj_id),
      }, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });

      if (res.data) {
        const successMessage = res.data.message || t("Mapping updated successfully");
        toast.success(<span style={{ whiteSpace: "pre-line" }}>{successMessage}</span>, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      }

      setIsActionLoading(false);
    } catch (err) {
      setIsActionLoading(false);
      const errorMessage = err?.response?.data?.message || t("Please try again");
      ToastError({ title: errorMessage });
    }
  };


  return (
    <>
      <Helmet>
        <title>{_t(t("Web Mapping"))}</title>
      </Helmet>
      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ManageSidebar />
            </div>
            <CustomSpinLoader loading={isActionLoading || loading} />
            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">

                <div
                  className="fk-scroll--pos-menu table-bottom-info-hide"
                  data-simplebar
                >

                  <div className="t-pl-15 t-pr-15">
                    {/* next page data spin loading */}
                    <div className={`${dataPaginating && "loading"}`}></div>
                    {/* spin loading ends */}

                    <div className="smtp-form">
                      <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                        <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0 ">
                          <ul className="t-list mb-3 fk-breadcrumb">
                            <li className="fk-breadcrumb__list">
                              <span className="t-link fk-breadcrumb__link text-capitalize">
                                {_t(t("Web Mapping"))}
                              </span>
                            </li>
                          </ul>
                        </div>
                        <div className="col-md-6 col-lg-7">
                          <div className="row gx-3 align-items-center"></div>
                        </div>
                        {/* Form starts here */}
                        <form
                          className="row card p-2 mx-3 sm-text my-2"
                          style={{ width: "97%" }}
                          onSubmit={handleSubmit}
                          autoComplete="off"
                        >

                          <div className="row pl-4 mt-3">
                            <div className="col-4 form-group">
                              <div className="mb-2">
                                <label
                                  className="control-label"
                                >
                                  {_t(t("Type"))}
                                  <span className="text-danger">*</span>
                                </label>
                              </div>
                              <div className="mb-2">
                                <Select
                                  options={webMapping ? webMapping : []}
                                  getOptionLabel={(option) => option.name}
                                  getOptionValue={(option) => option.id}
                                  value={mapping.type}
                                  onChange={(type) => handleSetType(type)}
                                  placeholder="Select Type"
                                  // styles={customStyle}
                                  isLoading={isFetching}
                                  isDisabled={isFetching}
                                />
                              </div>
                            </div>
                            <div className="col-4 form-group">
                              <div className="mb-2">
                                <label
                                  htmlFor="discount"
                                  className="control-label"
                                >
                                  {_t(t("Pos Id"))}
                                  <span className="text-danger">*</span>
                                </label>
                              </div>
                              <div className="mb-2">
                                <input type="text" className="form-control sm-plc-h"
                                  name="pos_id"
                                  onChange={handleChange}
                                  value={
                                    mapping.pos_id || ""
                                  }
                                  required
                                  placeholder="Pos id"
                                />
                              </div>
                            </div>

                            <div className="col-4 form-group">
                              <div className="mb-2">
                                <label
                                  className="control-label"
                                >
                                  {_t(t("Web Id"))}
                                  <span className="text-danger">*</span>
                                </label>
                              </div>
                              <div className="mb-2">
                                <input type="text" className="form-control sm-plc-h"
                                  name="web_id"
                                  onChange={handleChange}
                                  value={
                                    mapping.web_id || ""
                                  }
                                  required
                                  placeholder="Web id"
                                />
                              </div>
                            </div>

                          </div>

                          <div className="form-group mt-4 pb-3">
                            <div className="mr-4 float-right">
                              <button
                                className="btn btn-primary px-5 rounded"
                                type="submit"
                              >
                                {_t(t("Save"))}
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>

                    {mappingList && mappingList.length > 0 && (
                      <div className="row card p-2 mx-3 sm-text my-4" style={{ width: "97%" }}>
                        {/* Header Row */}
                        <div className="row pl-4 mt-3 mb-2">
                          <div className="col-3">
                            <strong>{_t(t("Name"))}</strong>
                          </div>
                          <div className="col-3">
                            <strong>{_t(t("Pos Id"))}</strong>
                          </div>
                          <div className="col-3">
                            <strong>{_t(t("Web Id"))}</strong>
                          </div>
                          <div className="col-3">
                            <strong>{_t(t("Actions"))}</strong>
                          </div>
                        </div>
                        <hr />

                        {/* Mapped Items */}
                        {mappingList.map((item, index) => {
                          return (
                            <div key={item.id} className="row pl-4 mt-3 align-items-center sm-text">
                              <div className="col-3 form-group">
                                <input
                                  type="text"
                                  className="form-control sm-text sm-plc-h"
                                  name="name"
                                  value={item?.name || ""}
                                  readOnly={true}
                                  placeholder=""
                                />
                              </div>
                              <div className="col-3 form-group">
                                <input
                                  type="text"
                                  className="form-control sm-text sm-plc-h"
                                  name="pos_id"
                                  value={item.pos_id || ""}
                                  onChange={(e) => handleItemChange("pos_id", e.target.value, index)}
                                  placeholder="Pos id"
                                />
                              </div>
                              <div className="col-3 form-group">
                                <input
                                  type="text"
                                  className="form-control sm-text sm-plc-h"
                                  name="web_id"
                                  value={item.indolj_id || ""}
                                  onChange={(e) => handleItemChange("indolj_id", e.target.value, index)}
                                  placeholder="Web id"
                                />
                              </div>
                              <div className="col-3 form-group">
                                <button
                                  type="button"
                                  className="btn btn-primary btn-sm mr-2 rounded sm-text"
                                  onClick={() => handleUpdate(item)}
                                >
                                  {_t(t("Update"))}
                                </button>

                              </div>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default WebMapping;